import { render } from "./AssetView.vue?vue&type=template&id=7a1be80c"
import script from "./AssetView.vue?vue&type=script&lang=js"
export * from "./AssetView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__